var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMeasures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4553_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 18.4519L1.67578 1.67773V18.4519H18.45Z",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    fill: "#555555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44922 14.6778H10.4815L5.44922 9.64551V14.6778Z",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.579 18.4521V17.194M10.0629 18.4521V17.194M7.54675 18.4521V17.194M5.03062 18.4521V17.194M1.67578 15.0972H2.93385M1.67578 12.5811H2.93385M1.67578 10.065H2.93385M1.67578 7.54883H2.93385",
    stroke: "white",
    strokeWidth: 1.67742,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4553_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20.129V20.129H0V0Z",
    fill: "#F2B338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMeasures);
export default __webpack_public_path__ + "static/media/card-measures.11c0a59950e25604868ce3fb611fd00b.svg";
export { ForwardRef as ReactComponent };